module.exports = __webpack_public_path__ + "ae87e7b4e2d3825919b9bc6c82039b80.woff2";